import { render, staticRenderFns } from "./BundleList.vue?vue&type=template&id=131f51c0&"
import script from "./BundleList.vue?vue&type=script&lang=js&"
export * from "./BundleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports